<template>
  <div class="box-offline">
    <div class="flex item-center">
      <div class="title">导购账单</div>
      <div
        class="check flex flex-center item-center"
        v-if="checkAll"
        @click="changeBillState"
      >
        <div class="icon_dui"></div>
        <div class="text">风控检测通过</div>
        <span
          class="hmicon icon-fanhui_top"
          :class="{ 'icon-fanhui_top-return': !billState }"
        ></span>
      </div>
      <div class="check check_cuo flex flex-center item-center" v-else>
        <div class="icon_cuo"></div>
        <div class="text">风控检测未通过</div>
      </div>

    </div>
    <div class="bill" v-if="billState">
      <div class="flex item-center bill-item flex-1">
        <div class="total flex flex-center item-center">
          <div>累计收益</div>
          <div class="num">
            {{ dataList0.total_money_profit_amount || 0 }}
          </div>
        </div>
        <div class="icon_dengyu"></div>
        <div class="item-div flex item-center ml10 flex-1">
          <div class="item flex">
            <div class="left">待提现</div>
            <div class="right">
              {{
                ToFixed(
                  dataList0.allow_getcash_money_amount +
                    dataList0.being_getcash_money_amount,
                  2
                ) || 0
              }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">已提现</div>
            <div class="right">
              {{ dataList0.has_getcash_money_amount || 0 }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">代发分销佣金</div>
            <div class="right">
              {{ dataList0.unlock_money_amount || 0 }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">充值</div>
            <div class="right">
              {{ dataList0.refund_money_amount || 0 }}
            </div>
          </div>
        </div>
        <div class="check flex flex-center item-center" v-if="check01">
          <div class="icon_dui"></div>
          <div class="text">一致</div>
        </div>
        <div class="check check_cuo flex flex-center item-center" v-else>
          <div class="icon_cuo"></div>
          <div class="text">风险警告</div>
        </div>
      </div>
      <div class="icon_dengyu jianhao2"></div>
      <div class="flex item-center bill-item flex-1">
        <div class="total flex flex-center item-center">
          <div>累计收入</div>
          <div class="num">{{ dataList0.flow3_input || 0 }}</div>
        </div>
        <div class="icon_dengyu"></div>
        <div class="item-div flex item-center ml10 flex-wrap flex-1">
          <div class="item flex">
            <div class="left">导提红包</div>
            <div class="right">
              {{ dataList0.receipt_order_profit || 0 }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">视频广告激励</div>
            <div class="right">{{ dataList0.video_ad || 0 }}</div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">分销佣金</div>
            <div class="right">
              {{ dataList0.share_commission_amount || 0 }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">充值</div>
            <div class="right">
              {{ dataList0.guider_recharge || 0 }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">其它</div>
            <div class="right">
              {{ dataList0.other_profit || 0 }}
            </div>
          </div>
        </div>
        <div class="check flex flex-center item-center" v-if="check02">
          <div class="icon_dui"></div>
          <div class="text">一致</div>
        </div>
        <div class="check check_cuo flex flex-center item-center" v-else>
          <div class="icon_cuo"></div>
          <div class="text">风险警告</div>
        </div>
      </div>
      <div class="icon_dengyu jianhao2"></div>
      <div class="flex item-center bill-item flex-1">
        <div class="total flex flex-center item-center">
          <div>累计支出</div>
          <div class="num">{{ dataList0.all_out_amount || 0 }}</div>
        </div>
        <div class="icon_dengyu"></div>
        <div class="item-div flex item-center ml10 flex-1">
          <div class="item flex">
            <div class="left">提现</div>
            <div class="right">
              {{ dataList0.get_cash_amount || 0 }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">退款</div>
            <div class="right">
              {{ dataList0.guider_refund_amount || 0 }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">其它</div>
            <div class="right">
              {{ dataList0.other_refund || 0 }}
            </div>
          </div>
        </div>
        <div class="check flex flex-center item-center" v-if="check03">
          <div class="icon_dui"></div>
          <div class="text">一致</div>
        </div>
        <div class="check check_cuo flex flex-center item-center" v-else>
          <div class="icon_cuo"></div>
          <div class="text">风险警告</div>
        </div>
      </div>
      <div class="icon_jiahao jianhao2"></div>
      <div class="flex item-center bill-item flex-1">
        <div class="total flex flex-center item-center">
          <div>余额</div>
          <div class="num">{{ dataList0.remainder || 0 }}</div>
        </div>
        <div class="icon_dengyu"></div>
        <div class="item-div flex item-center ml10 flex-1">
          <div class="item flex">
            <div class="left">在途</div>
            <div class="right">
              {{ dataList0.onroad || 0 }}
            </div>
          </div>
          <div class="icon_jiahao"></div>
          <div class="item flex">
            <div class="left">可提现</div>
            <div class="right">
              {{ dataList0.allow_getcash_money_amount || 0 }}
            </div>
          </div>
        </div>
        <div class="check flex flex-center item-center" v-if="check04">
          <div class="icon_dui"></div>
          <div class="text">一致</div>
        </div>
        <div class="check check_cuo flex flex-center item-center" v-else>
          <div class="icon_cuo"></div>
          <div class="text">风险警告</div>
        </div>
      </div>

      <div class="check check2 flex flex-center item-center" v-if="check05">
        <div class="icon_dui"></div>
        <div class="text">一致</div>
      </div>
      <div class="check check2_cuo flex flex-center item-center" v-else>
        <div class="icon_cuo"></div>
        <div class="text">风险警告</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ToFixed } from "@/utils/utils";
export default {
  components: {},
  props: {
    customerId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ToFixed,
      customerInfo: {},
      dataList0: {},
      check01: true,
      check02: true,
      check03: true,
      check04: true,
      check05: true,
      checkAll: true,
      billState: true,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryCustomerInfo(this.customerId);
  },
  mounted() {
  },
  methods: {
    async queryCustomerInfo(customerId) {
      this.customerInfo = [];
      this.dataList0 = {};      
      let dynamicQueryCondition = {
        customerId: customerId,
      };
      let params = {
        dynamicQueryCondition: dynamicQueryCondition,
        reportCode: "customer_reconciliation_formula",
      };
      const { code, result } = await this.$store.dispatch(
        "queryCustomerInfo",
        params
      );
      if (result) {
        this.customerInfo = result;
        this.dataList0 = this.customerInfo.dataList[0];
        if (
          (this.dataList0.total_money_profit_amount || 0) ==
          ToFixed(
            (this.dataList0.allow_getcash_money_amount || 0) +
              (this.dataList0.being_getcash_money_amount || 0) +
              (this.dataList0.has_getcash_money_amount || 0) +
              (this.dataList0.unlock_money_amount || 0) +
              (this.dataList0.refund_money_amount || 0),
            2
          )
        ) {
          this.check01 = true;
          console.log("check01一致");
        } else {
          this.check01 = false;
          console.log("check01不一致");
        }
        if (
          (this.dataList0.flow3_input || 0) ==
          ToFixed(
            (this.dataList0.receipt_order_profit || 0) +
              (this.dataList0.video_ad || 0) +
              (this.dataList0.share_commission_amount || 0) +
              (this.dataList0.guider_recharge || 0) +
              (this.dataList0.other_profit || 0),
            2
          )
        ) {
          this.check02 = true;
          console.log("check02一致");
        } else {
          this.check02 = false;
          console.log("check02不一致");
        }
        if (
          (this.dataList0.all_out_amount || 0) ==
          ToFixed(
            (this.dataList0.get_cash_amount || 0) +
              (this.dataList0.guider_refund_amount || 0) +
              (this.dataList0.other_refund || 0),
            2
          )
        ) {
          this.check03 = true;
          console.log("check03一致");
        } else {
          this.check03 = false;
          console.log("check03不一致");
        }
        if (
          (this.dataList0.remainder || 0) ==
          ToFixed(
            (this.dataList0.onroad || 0) +
              (this.dataList0.allow_getcash_money_amount || 0),
            2
          )
        ) {
          this.check04 = true;
          console.log("check04一致");
        } else {
          this.check04 = false;
          console.log("check04不一致");
        }
        if (
          (this.dataList0.total_money_profit_amount || 0) ==
            (this.dataList0.flow3_input || 0) &&
          (this.dataList0.flow3_input || 0) ==
            ToFixed(
              (this.dataList0.all_out_amount || 0) +
                (this.dataList0.remainder || 0),
              2
            )
        ) {
          this.check05 = true;
          console.log("check05一致");
        } else {
          this.check05 = false;
          console.log("check05不一致");
        }
        if(this.check01 && this.check02 && this.check03 && this.check04 && this.check05){
          this.checkAll = true;         
        }else{
          this.checkAll = false;
          this.billState = true;
        }
        this.$emit("checkAll", this.checkAll);
      }
    },
    changeBillState(){
      this.billState = !this.billState;
    },
  },
};
</script>
<style scoped lang="scss">
.icon_dengyu {
  background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-dengyu-gray.png")
    no-repeat;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
}
.icon_jiahao {
  background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-jia-gray.png")
    no-repeat;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  margin: 0 10px;
}
.icon_jianhao {
  background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-jian-gray.png")
    no-repeat;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  margin: 0 10px;
}
.icon_dui {
  background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-dui.png")
    no-repeat;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.icon_cuo {
  background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-warning.png")
    no-repeat;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.box-offline {
  background: #ffffff;
  .title {
    color: #222222;
    font-weight: bold;
    &::before {
      display: inline-block;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
    }
  }
  .bill {
    padding: 10px;
    border: 1px solid #dddddd;
    margin-top: 20px;
    .bill-item {
      margin-top: 5px;
    }
    .total {
      padding: 0 10px;
      min-width: 148px;
      height: 50px;
      background: #ffffff;
      border-radius: 8px;
      opacity: 1;
      border: 1px solid #ababab;
      font-weight: 500;
      color: #222222;
      font-size: 14px;
      margin-right: 10px;
      .num {
        font-size: 28px;
        font-weight: 600;
        // color: #e50065;
        color: #16141b;
        margin-left: 10px;
      }
    }
    .item-div {
      padding: 0 10px;
      // height: 56px;
      border-radius: 8px;
      opacity: 1;
      border: 1px dashed #ababab;
      .item {
        border: solid 1px #dddddd;
        height: 32px;
        border-radius: 8px;
        margin: 5px;

        .left {
          padding: 0 10px;
          background: #f1f2f5;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          color: #222222;
        }
        .right {
          padding: 0 10px;
          min-width: 35px;
          text-align: center;
          font-size: 14px;
          color: #222222;
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
  .check {
    min-width: 80px;
    height: 38px;
    padding: 0 10px;
    background: #e6f6ea;
    border-radius: 59px;
    opacity: 1;
    border: 1px solid #a4dbaf;
    color: #37b44f;
    font-size: 16px;
    margin-left: 20px;
  }
  .check_cuo {
    background: #ffbdb0;
    color: #424242;
    border: 1px solid #ffbdb0;
  }
  .check2_cuo {
    background: #ffbdb0;
    color: #424242;
    border: 1px solid #ffbdb0;
    margin-left: 15px;
    margin-top: 12px;
    display: block;
    width: 120px;
  }
  .check2 {
    margin-left: 35px;
    margin-top: 12px;
    display: block;
    width: 80px;
  }
  .dengyu2 {
    transform: rotate(90deg);
    margin-top: 12px;
    margin-left: 65px;
  }
  .jianhao2 {
    margin-top: 5px;
    margin-left: 65px;
  }
  .icon-fanhui_top {
    font-size: 10px;
    margin-left: 10px;
  }
  .icon-fanhui_top-return {
    transform: rotate(180deg);
  }
}
</style>
